<template>
  <a-layout class="admin-wrapper">
    <AdminHeader @drawerBack="drawerChange" />
    <a-layout>
      <AdminSidebar />
      <a-layout-content class="admin-content-nav">
        <transition name="zoom-fade" mode="out-in" appear>
          <keep-alive v-if="$route.meta.keepalive">
            <router-view></router-view>
          </keep-alive>
          <router-view :key="key" v-if="!$route.meta.keepalive"></router-view>
        </transition>
      </a-layout-content>
    </a-layout>
  </a-layout>
</template>

<script>
import AdminHeader from "./components/AdminHeader";
import AdminSidebar from "./components/AdminSidebar.vue";
import { mapState, mapMutations } from "vuex";
export default {
  computed: {
    ...mapState("setting", ["isMobile"]),
    key() {
      return this.$route.path + Math.random();
    },
  },
  components: {
    AdminHeader,
    AdminSidebar,
  },
  data() {
    return {
      drawerOpen: false, // 是否打开侧边抽屉
    };
  },
  created() {
    // 是否缩是移动端
    this.util.enquireScreen(val_isMobile => {
      // 保存是否是移动端
      this.setIsMobile(val_isMobile);
      // 严谨判断，当切换是否移动端时，把是否缩小菜单和打开侧开还原
      if (!val_isMobile) {
        this.closeDrawer();
      } else {
        this.$store.commit("setting/setCollapsed", false);
      }
    });
    // this.getMenu();
  },
  mounted() {
    // this.$refs.allinfoModal.open();
  },
  methods: {
    ...mapMutations("setting", ["setIsMobile"]),

    closeDrawer() {
      this.drawerOpen = false;
    },
    drawerChange(data) {
      this.drawerOpen = data;
    },
    // 存当前路由的上级父路由，后面备用
    getMenu() {
      // const menuData = this.$router.options.routes || [];
      // menuData.forEach(item => {
      //   if (_.findIndex(item.children, { name: this.$route.name }) > -1) {
      //     // 存当前路由的上级父路由，后面备用
      //     this.$store.commit("changeMenuParent", item);
      //   }
      // });
    },
  },
  watch: {
    $route: function() {
      // 路由改变时执行
      this.getMenu();
    },
  },
};
</script>
<style></style>
